const zhCN = {
  public: {
    noauth: '请先连接钱包',
    login: '连接钱包',
    logout: '退出',
    confirm: '确认',
    cancel: '取消',
    loading: '加载中...',
    noData: '暂无数据',
    copy: '复制',
    balance: '余额',
    max: '最大',
    amount: '数量',
    from: '从',
    to: '到',
    price: '价格',
    fee: '手续费',
    slippage: '滑点容差',
    multipath: '多路径',
  },
  home: {
    home1: 'EOS 区块链上的\n去中心化交易',
    home2: '体验闪电般快速的兑换与最低的手续费。\nTotoro Swap 让所有人都能参与 DeFi 交易。',
    home3: '超低交易费用',
    home4: '交易手续费低至0.3%。高效的AMM协议确保您在每次兑换中获得最佳费率和最小滑点。',
    home5: '多钱包支持',
    home6: '连接 Anchor、TokenPocket、MetaMask、Scatter 等钱包。使用您喜爱的 EOS 钱包无缝交易。',
    home7: '创建\n账号',
    home8: '连接\n钱包',
    home9: '开始\n交易',
    home10: 'Totoro Swap是EOS上的去中心化交易所。',
    home11: '低手续费',
    home12: '交易手续费低至0.2%。',
    home13: '支持多种钱包。',
    card1Title: '兑换交易',
    card1Desc: '即时代币兑换，最优路由，最小滑点。',
    card2Title: '流动性池',
    card2Desc: '提供流动性赚取交易手续费，APY透明可见。',
    card3Title: '借贷市场',
    card3Desc: '以有竞争力的利率和灵活条款借入和借出资产。',
  },
  nav: {
    home: '首页',
    trade: '交易',
    swap: '兑换',
    liquidity: '流动性',
    lend: '借贷',
    market: '市场',
    assets: '资产',
    mining: '挖矿',
    tradeMining: '交易挖矿',
    liquidityMining: '流动性挖矿',
    lendMining: '借贷挖矿',
    vault: '金库',
    tools: '工具',
    createAccount: '创建账号',
  },
  swap: {
    swap: '兑换',
    pool: '池子',
    swapRecord: '兑换记录',
    liquidityRecord: '做市记录',
    addLiquidity: '添加流动性',
    removeLiquidity: '移除流动性',
    createMarket: '创建市场',
    selectToken: '选择代币',
    enterAmount: '请输入数量',
    insufficientBalance: '余额不足',
    priceImpact: '价格影响',
    minimumReceived: '最低收到',
    route: '路由',
    success: '交易成功',
    loadMore: '加载更多',
    myLiquidity: '我的流动性',
    liquidityRatio: '流动性占比',
    currentLiquidity: '当前流动性',
    costBasis: '投入本金',
    profit: '收益',
    poolReserves: '流动性',
    availableCertificate: '可用凭证',
    withdrawAssets: '提取资产',
    addLiquiditySuccess: '添加流动性成功',
    removeLiquiditySuccess: '移除流动性成功',
    createMarketSuccess: '创建市场成功',
    sameTokenError: '不能选择相同的代币',
    pairExistsError: '该交易对已存在',
    tokenNotFound: '代币不存在',
    tokenName: '代币名称',
    enterTokenName: '请输入代币符号',
    enterContractAddress: '请输入合约账号',
    tokenInfoEmpty: '代币信息不能为空',
    noPairFound: '未找到交易对',
    noPool: '暂无流动性池',
    add: '添加',
    remove: '移除',
    certificate: '凭证',
  },
  lend: {
    deposit: '存入',
    withdraw: '取出',
    borrow: '借入',
    repay: '还款',
    totalDeposit: '总存款',
    totalBorrow: '总借款',
    depositApy: '存款APY',
    borrowApy: '借款APY',
    walletBalance: '钱包余额',
    myDeposit: '我的存款',
    myBorrow: '我的借款',
  },
  mining: {
    totalReward: '总奖励',
    tvl: 'TVL',
    dailyEmission: '每日产出',
    earned: '已赚取',
    stake: '质押',
    unstake: '解除质押',
    claim: '领取',
    live: '进行中',
    finished: '已结束',
    stakedOnly: '仅已质押',
  },
  vault: {
    overview: '概览',
    deposit: '存入',
    withdraw: '取出',
    totalValue: '总价值',
    apy: 'APY',
  },
  tools: {
    createAccount: '创建EOS账号',
    accountName: '账户名',
    accountNameTip: '必须12个字符（a-z, 1-5, .）',
    create: '创建',
    remaining: '剩余',
    createTipTitle: '使用说明',
    createTip1: '请妥善保存好自己生成的私钥！如果私钥丢失新注册的账号将丢失！',
    createTip2: '注册费用为系统收取，本服务为公益服务，0抽水',
    createTip3: '如果想自助注册，直接发送大于0.06EOS到合约账户signup.free，按以下格式填memo：[12位用户名]-[公钥]',
    createTip4: '例如：itlnmuw2ywh-EOS4wXEq8fXfg4uvi344Fvq6x1REimGDF56dDoPiFcZ9qpRtPyahY',
    createTip5: '超过部分EOS将会自动转到你新建的账号上，注册好账号后就可以导入钱包使用了，如果您在电脑上使用，推荐您使用目前体验最好的<a href="https://metahub.cash" target="_blank">Metahub网页钱包</a>，下载地址：<a href="https://metahub.cash" target="_blank">https://metahub.cash</a>',
    createTip6: '<span style="color:#4ea95c">免费创建账号</span>服务由<a href="https://metahub.cash" target="_blank">Metahub</a>提供，每小时限量，先到先得',
  },
  error: {
    canceled: '交易已取消',
    error3080001: 'CPU资源不足',
    error3080002: 'NET资源不足',
    error3080004: '超时',
    error3040005: '交易过期',
    error3090003: '授权不满足',
  },
  toastTip: {
    loginSuccess: '钱包已连接',
    logoutSuccess: '退出成功',
    copySuccess: '复制成功',
    copyFail: '复制失败',
  },
  about: {
    title: '关于 Totoro',
    copyright: 'Totoro Swap',
    github: 'GitHub',
    audit: '审计报告',
  },
  settings: {
    title: '设置',
    slippage: '滑点容差',
    custom: '自定义',
    multipath: '多路径兑换',
    rpcNode: 'RPC节点',
    language: '语言',
  },
  login: {
    title: '连接钱包',
    web: '网页钱包',
    mobile: '移动端钱包',
  },
} as const

export default zhCN
